export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const currencyFormat = (num) => parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/,',$1');

